// extracted by mini-css-extract-plugin
module.exports = {"title":"viti_interaction_phone_section-module--title--3rSgj"};